import { useUserStore } from '@/stores/user.js';

export function subscribeToCustomerCompanyNotifications(onGeneralNotification) {
    const userStore = useUserStore();
    const customerCode = userStore.profile.customer_code;
    const company_id = userStore.profile.company_id;

    // Si el usuario no tiene company_id, no suscribirse
    if (!company_id) {
        console.warn('Usuario sin company_id, no se puede suscribir a notificaciones de empresa');
        return null;
    }

    const channelName = `${customerCode}-${company_id}`;

    const channel = window.Echo.channel(channelName)
        .listen('.general.notification', (event) => {
            console.log('General notification (company):', event);
            onGeneralNotification?.(event); // Llamar directamente al callback
        });

    // Guarda el nombre del canal por si lo necesitas luego
    channel.name = channelName;

    return channel;
}

export function unsubscribeFromCustomerCompanyNotifications(channel) {
    if (channel?.name) {
        window.Echo.leave(channel.name);
        console.log(`Desconectado del canal ${channel.name}`);
    }
}
